import React, { useState } from "react";
import styled from "styled-components";
import Icon from "../Icons/Icon";

const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 10px;
`;

const AccordionHeader = styled.div`
  background-color: transparent;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: border-bottom 0.2s ease;
  border-bottom: ${(props) => (props.open ? "none" : "1px solid #ccc")};
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const AccordionContent = styled.div`
  background-color: transparent;
  height: ${(props) => (props.open ? "auto" : "0")};
  overflow: hidden;
  transition: height 0.3s ease, opacity 0.3s ease, border-bottom 0.3s ease;
  opacity: ${(props) => (props.open ? "1" : "0")};
  padding: ${(props) => (props.open ? "10px 10px 10px 50px" : "0 10px 0 50px")};
  border-bottom: 1px solid #ccc;
`;

const Accordion = ({ title, eyebrow, color, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <AccordionWrapper>
      <AccordionHeader onClick={toggleAccordion} open={isOpen}>
        <TitleWrapper>
          {eyebrow}
          {title}
        </TitleWrapper>
        <Icon name={isOpen ? "minus" : "plus"} size="24px" color={color} />
      </AccordionHeader>
      <AccordionContent open={isOpen}>{children}</AccordionContent>
    </AccordionWrapper>
  );
};

export default Accordion;
